export const TICK_FREQUENCY_MS = 1000
export const SPECIMENT_LOADING_TIMEOUT_MS = 5000
export const MAX_Y_AXIS_MS = 1500
export const NUM_OF_SPECIMENTS = 30
export const ACCEPTED_STANDARD_DEVIATION = 30
export const TOLERANCE_LATENCY = 500
